<script setup lang='ts'>

</script>

<template>
  <div class="mx-auto max-w-7xl px-4">
    <slot />
  </div>
</template>
